// import jQuery from 'CommonScripts/jquery-1.10.2'; 
    
(function (window, document, $) {
    'use strict';
    $(document).ready(function () {
        $('.tagsimulator_spot').each(function () {
            var vm = $(this);
            var labelId = 0;
            $(window).load(function () {
                vm.find('.selection > .fakeMultiSelect').each(function () {
                    var sLi = $(this);
                    var sForm = sLi.find('select');
                    sForm.attr('multiple', true);
                    sForm.find('option').each(function () {
                        var sOpt = $(this);
                        var optionSelected = sOpt.is(':selected');
                        var checkedVal;
                        labelId++;
                        if (optionSelected) { checkedVal = 'checked'; } else { checkedVal = ''; }
                        sLi.find('ul').append('<li><input id="fakeForm' + labelId + '" type="checkbox" name="' + sForm.attr('name') +
                            'fake" value="' + sOpt.val() + '" ' + checkedVal + ' /><label for=fakeForm' + labelId + '>' +
                            sOpt.text() + '</label></li><br>');

                        sLi.find('h4').each(function () {
                            var fakePaddingleft = Number($(this).css('padding-left').substr(0, $(this).css('padding-left').length - 2));
                            var fakePaddingright = Number($(this).css('padding-right').substr(0, $(this).css('padding-right').length - 2));
                            var fakeTitle = $(this).width() + fakePaddingleft + fakePaddingright;
                            var fakeDrop = $(this).siblings('ul');
                            if (fakeTitle < fakeDrop.width()) {
                                $(this).width(fakeDrop.width() - fakePaddingleft - fakePaddingright);
                            } else {
                                fakeDrop.width(fakeTitle);
                            }
                        });
                    });
                    sLi.find('input').change(function () {
                        var chBox = $(this);
                        if (chBox.is(':checked')) {
                            vm.find('option[value="' + chBox.val() + '"]').prop('selected', true);
                        } else {
                            vm.find('option[value="' + chBox.val() + '"]').prop('selected', false);
                        }
                    });
                });
                vm.find('.selection > .fakeSelect').each(function () {
                    var sLi = $(this);
                    var sForm = sLi.find('select');
                    sForm.find('option').each(function () {
                        var sOpt = $(this);
                        var optionSelected = sOpt.is(':selected');
                        var checkedVal;
                        if (optionSelected) { checkedVal = 'fakeSelected'; } else { checkedVal = ''; }
                        sLi.find('ul').append('<li data-value="' + sOpt.val() + '" class="' + checkedVal + '">' + sOpt.text() + '</li><br>');

                        sLi.find('h4').each(function () {
                            var fakePaddingleft = Number($(this).css('padding-left').substr(0, $(this).css('padding-left').length - 2));
                            var fakePaddingright = Number($(this).css('padding-right').substr(0, $(this).css('padding-right').length - 2));
                            var fakeTitle = $(this).width() + fakePaddingleft + fakePaddingright;
                            var fakeDrop = $(this).siblings('ul');
                            console.log(fakeTitle+'a');
                            console.log(fakeDrop.width() + 'b');
                            if (fakeTitle < fakeDrop.width()) {
                                $(this).width(fakeDrop.width() - fakePaddingleft - fakePaddingright);
                            } else {
                                fakeDrop.width(fakeTitle);
                            }
                        });
                    });
                    sLi.find('li').click(function () {
                        var chBox = $(this);
                        if (chBox.hasClass('fakeSelected')) {
                            
                        } else {
                            vm.find('option[value="' + chBox.attr('data-value') + '"]').prop('selected', true);
                            sLi.find('li').removeClass();
                            chBox.addClass('fakeSelected');
                        }
                    });
                });
                vm.find('h4').click(function () {
                    var fakeDropTitle = $(this);
                    var fakeDropdown = $(this).siblings('ul');
                    fakeDropdown.toggle('fast');
                });
            });
        });

        $('.preview_related_spot').each(function () {
            var vm = $(this);
            $(window).load(function () {
                vm.imagesLoaded().fail(function () {
                    vm.find('.article-wrapper').addClass('placeholder-img');
                    vm.find('.image-wrapper img').remove();
                    vm.find('.placeholder-img > .image-wrapper').width('100%');

                    var vmHeight = vm.closest('body').height();
                    $('#scContentIframeId0', window.parent.document).height(vmHeight);
                });
                if (vm.find('img').length === 0) {
                    vm.find('.article-wrapper').addClass('placeholder-img');
                    vm.find('.image-wrapper img').remove();
                    vm.find('.placeholder-img > .image-wrapper').width('100%');

                    var vmHeight = vm.closest('body').height();
                    $('#scContentIframeId0', window.parent.document).height(vmHeight);
                }
                vm.imagesLoaded().done(function () {
                    var vmHeight = vm.closest('body').height();
                    $('#scContentIframeId0', window.parent.document).height(vmHeight);
                });
                vm.closest('body').css('min-height', '100%');
                vm.find('.grid_12').css({ 'margin-left': '19px', 'line-height': '0' });

                vm.find('a').click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
        });

        $('.related_spot').each(function () {
            var vm = $(this);
            $(window).load(function () {
                vm.imagesLoaded().fail(function () {
                    vm.find('.grid_4').each(function () {
                        var block = $(this);
                        block.imagesLoaded().fail(function () {
                            block.find('.article-wrapper').addClass('placeholder-img');
                            block.find('.image-wrapper img').remove();

                            setTimeout(function () {
                                if ($('#main').width() > 768) {
                                    var heights = [];
                                    var i = 0;
                                    var maxHeight = 0;
                                    block.siblings('.grid_4').each(function () {
                                        heights[i] = $(this).find('img').height();
                                        i++;
                                    });
                                    for (var j = 0; j < heights.length; j++) {
                                        maxHeight = Math.max(heights[j], maxHeight);
                                    }
                                    block.children('.article-wrapper').height(maxHeight);
                                }
                            }, 0);
                        });
                    });
                });
            });
        });

        $('.related_spot').each(function () {
            var vm = $(this);
            if (vm.children().length === 0) {
                vm.closest('section').css({ 'padding': '0' });
            }
        });

        $('.internal-block').each(function () {
            var block = $(this);
            block.imagesLoaded().fail(function () {
                block.find('.image-wrapper img').hide();
            });
        });

        $('.itemTag').each(function () {
            var vm = $(this);
            if (vm.text().length === 0) {
                if (vm.parent().parent().hasClass('removable-wrapper')) {
                    vm.parent().parent().removeClass('removable-wrapper');
                }
                vm.remove();
            }
        });

    });
})(window, document, jQuery);